export const BASE_FARE = "Base fare";
export const DUE_AT_PICKUP = "Due at pick-up";
export const TAXES_AND_FEES = "Taxes & fees";
export const TRIP_TOTAL = "Total";
